import React from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import VoteButtonsMini from "components/card//VoteButtonsMini";
import useAuth from "hooks/auth/useAuth";
import usePredictorVotes from "hooks/predictors/usePredictorVotes";
import PointsDisplay from "components/card/PointsDisplay";
import { calculatePoints } from "libs/utils";

const PredictorCard = ({ predictor }) => {
  const { handleVote } = usePredictorVotes();
  const router = useRouter();
  const { currentUser } = useAuth();
  const points = predictor.votes ? calculatePoints(predictor.votes).points : 0;
  const predictorId = predictor.id || predictor.objectID || predictor._id;

  const handleNavigate = (e) => {
    e?.stopPropagation();
    if (predictorId) {
      router.push(`/predictors/${predictorId}`);
    }
  };

  return (
    <div
      style={{ fontFamily: "Noto Sans Armenian" }}
      className="flex flex-col sm:flex-row md:flex-col items-center justify-between gap-3 sm:gap-4 p-4 sm:p-5 md:py-8 md:px-6 rounded-2xl md:rounded-[28px] bg-white dark:bg-[#0c0a1f] border border-slate-100 dark:border-white/10 shadow-[0_4px_24px_rgba(0,0,0,0.03)] hover:shadow-lg transition-all duration-300 w-full h-full"
    >
      <div
        onClick={handleNavigate}
        className="flex flex-row sm:flex-row md:flex-col gap-3 sm:gap-4 items-center cursor-pointer flex-1 text-left md:text-center w-full min-w-0"
      >
        <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-28 md:h-28 shrink-0 rounded-full border-2 md:border-4 border-[#0033FF] overflow-hidden shadow-sm hover:scale-105 transition-transform">
          <Image
            width={112}
            height={112}
            src={predictor.image || "/defaultuserprofile.webp"}
            alt="person"
            priority
            className="object-cover w-full h-full"
          />
        </div>
        <div className="flex flex-col justify-center items-start md:items-center gap-1 min-w-0 flex-1">
          <span
            onClick={handleNavigate}
            className="text-slate-900 dark:text-white text-sm sm:text-base md:text-lg font-bold truncate w-full cursor-pointer hover:text-[#0033FF] transition-colors"
          >
            {predictor.firstName} {predictor.lastName}
          </span>
          <div className="flex items-center gap-1.5 bg-[#f0f4ff] dark:bg-slate-900 px-2.5 py-0.5 md:px-3 md:py-1 rounded-xl">
            <span className="text-[#0033FF] font-black text-xs md:text-sm">
              {predictor.collectedPoints || points || 60}%
            </span>
            <span className="text-slate-500 dark:text-slate-400 text-[10px] md:text-xs font-semibold uppercase">
              Կանխատեսումներ
            </span>
          </div>
        </div>
      </div>
      <div className="shrink-0 flex items-center justify-end w-full sm:w-auto md:w-full md:justify-center md:mt-2">
        <VoteButtonsMini
          currentUser={currentUser}
          state={predictor.votes?.[currentUser?.uid] || ""}
          onChange={(state) => {
            if (predictorId) {
              handleVote(predictorId, currentUser?.uid, state);
            }
          }}
        />
      </div>
    </div>
  );
};

export default PredictorCard;
